// @ts-nocheck
// import StoreProductDetailsInformations from "@store/Library/Components/Foundation/StoreProduct/StoreProductDetailsInformations"; // Store Custom Code
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
// import React from "react"; // Store Custom Code

/* Store Custom Code - Start */
import useHeaderOpacity from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useHeaderOpacity";
import StoreProductDetailsInformations from "@store/Library/Components/Foundation/StoreProduct/StoreProductDetailsInformations";
import React, { useEffect } from "react";
/* Store Custom Code - End */

const enum fields {
    disableOutOfStockVariants = "disableOutOfStockVariants",
    showSizingChart = "showSizingChart",
    showSeriesBadge = "showSeriesBadge",
    seriesBadgeWidth = "seriesBadgeWidth",
    attributes = "attributes",
    attributeName = "attributeName",
    fallbackOnNormalAttributeType = "fallbackOnNormalAttributeType",
    // Store Custom Code
    hideDropdownIfOnlyOneVariant = "hideDropdownIfOnlyOneVariant",
}

const enum fieldsEnum {
    attributeName = "attributeName",
}

export type AttributeModel = {
    fields: {
        [fieldsEnum.attributeName]: string;
    };
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.disableOutOfStockVariants]: boolean;
        [fields.showSizingChart]: boolean;
        [fields.showSeriesBadge]: boolean;
        [fields.seriesBadgeWidth]: number;
        [fields.attributes]: AttributeModel[];
        [fields.fallbackOnNormalAttributeType]: boolean;
        // Store Custom Code
        [fields.hideDropdownIfOnlyOneVariant]: boolean;
    };
}

const ProductDetailsInformations: React.FC<OwnProps> = ({ fields }) => {
    /* Store Custom Code - Start */
    const { manuallySetFullOpacity, isFullOpacity } = useHeaderOpacity();

    useEffect(() => {
        manuallySetFullOpacity(true);

        return () => {
            manuallySetFullOpacity(false);
        };
    }, [isFullOpacity]);
    /* Store Custom Code - End */

    return (
        <StoreProductDetailsInformations
            disableOutOfStockVariants={fields.disableOutOfStockVariants}
            showSizingChart={fields.showSizingChart}
            showSeriesBadge={fields.showSeriesBadge}
            seriesBadgeWidth={fields.seriesBadgeWidth}
            selectedAttributes={fields.attributes?.map(x => x.fields[fieldsEnum.attributeName]) || []}
            fallbackOnNormalAttributeType={fields.fallbackOnNormalAttributeType}
            // Store Custom Code
            hideDropdownIfOnlyOneVariant={fields.hideDropdownIfOnlyOneVariant}
        />
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsInformations,
    definition: {
        group: "Product Details",
        displayName: "Product Details Informations",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.disableOutOfStockVariants,
                displayName: "Disables the variants that are out of stock.",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
            {
                name: fields.showSizingChart,
                displayName: "Shows the sizing charts.",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
            {
                name: fields.showSeriesBadge,
                displayName: "Shows the series badges.",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
            {
                name: fields.seriesBadgeWidth,
                displayName: "Series badge width",
                editorTemplate: "IntegerField",
                fieldType: "General",
                defaultValue: 35,
                isRequired: false,
                tooltip: "the width is in px.",
                isVisible: widget => widget.fields.showSeriesBadge,
            },
            {
                name: fields.attributes,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.attributeName;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: fieldsEnum.attributeName,
                        displayName: "Tap the attribute you want to display",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.fallbackOnNormalAttributeType,
                displayName: "Fallback on the normal attribute types order if the one selected are not found",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            // Store Custom Code
            {
                name: fields.hideDropdownIfOnlyOneVariant,
                displayName: "Hide The Dropdown If There Is Only One Variant",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
        ],
    },
};

export default widgetModule;
